// Product descriptions come from the backend catalog in an inconsistent format.
// Many are " - "-delimited attribute lists (e.g. "Coverage: Tropical regions -
// natural lands - License: Non-Commercial"), others are real prose. Parse the
// delimited ones into structured items; leave everything else as prose.

const KEY_VALUE_RE = /^([A-Z][\w ]{1,20}):\s*(.+)$/;
const MAX_ITEM_LENGTH = 120;
const MIN_PARTS = 3;

export function parseDescription(raw) {
  const text = (raw ?? '').trim();
  if (!text) return {mode: 'prose', items: [], text: ''};

  // Split on space-hyphen-space so hyphenated words ("Non-Commercial",
  // "single-user") are never broken apart.
  const parts = text
    .split(/\s+-\s+/)
    .map(p => p.trim())
    .filter(Boolean);

  const looksDelimited =
    parts.length >= MIN_PARTS && parts.every(p => p.length <= MAX_ITEM_LENGTH);

  if (!looksDelimited) return {mode: 'prose', items: [], text};

  const items = parts.map(part => {
    const match = part.match(KEY_VALUE_RE);
    return match ? {key: match[1], value: match[2]} : {value: part};
  });

  return {mode: 'list', items, text};
}

const normalizeForCompare = value =>
  (value ?? '').toLowerCase().replace(/[^a-z0-9]/g, '');

// Backend descriptions usually lead with the product name (e.g. "Planet
// Agriculture Premium (Tier 1)"), which just restates the page title. Drop that
// leading keyless item so it isn't shown twice under the H1. Matching ignores
// case and punctuation so "... (Tier 1)" collapses onto "... Tier 1".
export function dropRedundantTitleItem(items, title) {
  const isRedundantLead =
    items.length &&
    !items[0].key &&
    normalizeForCompare(items[0].value) === normalizeForCompare(title);

  return isRedundantLead ? items.slice(1) : items;
}
